import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';

import { AlertComponent } from '../../shared/components/alert/alert.component';
import { LoadingComponent } from '../../shared/components/loading/loading.component';
import { ValueCardComponent } from '../../shared/components/value-card/value-card.component';
import { OrdersService } from '../../core/services/order/order.service';
import { ParsedStats, StatsResponse } from '../../core/models/order/order-statistics.model';
import { parseStatistics } from '../../core/helpers/order-statistics.helper';
import { formatBRLFromCents } from '../../core/helpers/currency.helper';
import { currentHourBR } from '../../core/helpers/date-timer.helper';

interface SalesChannel {
  id: number | null;
  label: string;
}

const SALES_CHANNELS: SalesChannel[] = [
  { id: null, label: 'Todos os canais' },
  { id: 1, label: 'Site B2C' },
  { id: 2, label: 'App do vendedor' },
  { id: 6, label: 'Site B2B' },
  { id: 7, label: 'Site incentivos' },
  { id: 10, label: 'App do cliente' },
];

@Component({
  selector: 'app-revenue-overview',
  standalone: true,
  imports: [FormsModule, AlertComponent, LoadingComponent, ValueCardComponent],
  templateUrl: './revenue-overview.component.html',
  styleUrl: './revenue-overview.component.scss',
})
export class RevenueOverviewComponent implements OnInit, OnDestroy {
  initialLoading = true;
  refreshing = false;
  error?: string;
  parsed?: ParsedStats;

  channels = SALES_CHANNELS;
  selectedChannelId: number | null = null;

  protected readonly formatBRLFromCents = formatBRLFromCents;
  protected readonly currentHourBR = currentHourBR;

  private fetchSub?: Subscription;

  constructor(private orderService: OrdersService) {}

  ngOnInit(): void {
    this.fetchStatistics();
  }

  ngOnDestroy(): void {
    this.fetchSub?.unsubscribe();
  }

  onChannelChange(): void {
    this.fetchStatistics();
  }

  private fetchStatistics(): void {
    this.fetchSub?.unsubscribe();
    this.refreshing = true;
    this.error = undefined;

    this.fetchSub = this.orderService.statistics(this.selectedChannelId ?? undefined).subscribe({
      next: (data: StatsResponse) => {
        this.parsed = parseStatistics(data);
        this.initialLoading = false;
        this.refreshing = false;
      },
      error: (err) => {
        this.error = 'Não foi possível carregar os dados de faturamento.';
        this.initialLoading = false;
        this.refreshing = false;
        console.error(err);
      },
    });
  }
}
